module.exports = __webpack_public_path__ + "submenu_index_1_active.6af48d19.png";